import { Button, Switch, TextField, Typography } from '@mui/material';
import { alpha, styled } from '@mui/material/styles';

export const RootStyled = styled('div')(({ theme }) => ({
  padding: theme.spacing(8),
}));

export const HeaderPageStyled = styled('div')({
  display: 'flex',
  flexDirection: 'column',
  justifyContent: 'flex-start',
  alignItems: 'flex-start',
  gap: 32,
  '& button': {
    marginLeft: -16,
  },
});

export const MainContainerStyled = styled('div')({
  display: 'flex',
  justifyContent: 'space-between',
  alignItems: 'center',
  width: '100%',
});

export const DeleteButtonStyled = styled(Button)({
  display: 'flex',
  alignItems: 'center',
  gap: 8,
  cursor: 'pointer',
  color: '#FF0000',
  '& .icon': {
    fontSize: 20,
    marginRight: 10,
  },
});

export const SectionTitleStyled = styled(Typography)({
  fontWeight: 400,
  margin: '48px 0 36px 0',
});

export const DivGroupStyled = styled('div')({
  display: 'flex',
  gap: 16,
  marginBottom: 16,
});

export const ShortInputStyled = styled(TextField)({
  width: '10%',
});

export const CustomSwitchStyled = styled(Switch)(({ theme }) => ({
  width: 41,
  height: 21,
  padding: 0,
  borderRadius: 21,
  '&:active': {
    '& .MuiSwitch-thumb': {
      width: 16,
    },
    '& .MuiSwitch-switchBase.Mui-checked': {
      transform: 'translateX(9px)',
    },
  },
  '& .MuiSwitch-switchBase': {
    padding: 2,
    '&.Mui-checked': {
      transform: 'translateX(21px)',
      color: alpha(theme.palette.secondary.main, 1),
      '& + .MuiSwitch-track': {
        opacity: 1,
        backgroundColor:
          theme.palette.mode === 'dark'
            ? '#177ddc'
            : theme.palette.primary.main,
      },
    },
  },
  '& .MuiSwitch-thumb': {
    boxShadow: '0 2px 4px 0 rgb(0 35 11 / 20%)',
    width: 17,
    height: 17,
    transition: theme.transitions.create(['width'], {
      duration: 200,
    }),
  },
  '& .MuiSwitch-track': {
    borderRadius: 16 / 2,
    opacity: 1,
    backgroundColor:
      theme.palette.mode === 'dark'
        ? 'rgba(255,255,255,.35)'
        : 'rgba(0,0,0,.25)',
    boxSizing: 'border-box',
  },
}));

export const BtnSubmitStyled = styled(Button)(({ theme }) => ({
  fontWeight: 600,
  height: 42,
  width: 200,
  marginTop: 18,
  color: theme.palette.global.white,
  fontSize: '12px',
}));

export const FacadeTitleStyled = styled(Typography)({
  fontWeight: 400,
  margin: '12px 0',
});
